import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AnalyticsInitService } from './shared/services/analytics-init.service';
import { InfoModalComponent } from './shared/components/info-modal/info-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, InfoModalComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private analyticsInitService: AnalyticsInitService) {}

  ngOnInit(): void {
    // Inicializar Google Analytics según el ambiente
    this.analyticsInitService.initializeAnalytics();
  }
}
